import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material/";
import withStyles from "@mui/styles/withStyles";
import PropTypes from "prop-types";

import location from "../../img/dropdown-icons/Address.svg";
import website from "../../img/dropdown-icons/Website.svg";
import phone from "../../img/dropdown-icons/Phone.svg";
import { UserContext } from "../../UserContext.js";

const styles = (theme) => ({
  container: {
    textAlign: "left",
  },
  img: {
    maxWidth: "100%",
    height: "auto",
    maxHeight: 250,
    cursor: "pointer",
  },
  spacing: {
    fontSize: 16,
    cursor: "pointer",
    fontWeight: "bold",
    color: "black",
  },
  noWrap: {
    wordWrap: "break-word",
  },
  underline: {
    textDecoration: "underline",
  },
  spaceTop: {
    padding: 10,
  },
  margin: {
    position: "relative",
    top: 4,
    marginRight: 7,
    height: 20,
    width: 20,
  },
  align: {
    textAlign: "left",
  },
});

const Header = (props) => {
  const { settings, businessInfo, canViewComments, access_token, userInfo } =
    useContext(UserContext);
  const { hasBusinessLocations } = businessInfo;
  const {
    displayLogo,
    displayCompanyAddress,
    displayCompanyURL,
    displayCompanyPhoneNumber,
  } = settings;
  const { classes } = props;
  const [logoUrl, setLogoUrl] = useState("");
  const { permissions } = userInfo;

  if (hasBusinessLocations && permissions?.length) {
    const { businessLocationPermissions } = permissions[0];
    if (businessLocationPermissions?.length === 1) {
      const { businessLocation } = businessLocationPermissions[0];
      const { address1, address2, city, state, postalCode } =
        businessLocation?.address;
      const { webPage, workNumber } = businessLocation;
      businessInfo.address1 = address1;
      businessInfo.address2 = address2;
      businessInfo.city = city;
      businessInfo.state = state;
      businessInfo.postalCode = postalCode;
      businessInfo.webPage = webPage;
      businessInfo.phoneNumber = workNumber;
    }
  }

  const { address1, address2, city, state, postalCode, phoneNumber, webPage } =
    businessInfo;

  const address = [
    [address1, address2].filter(Boolean).join(" "),
    [city, state, postalCode].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(" ");

  useEffect(() => {
    const getLogo = async () => {
      if (!businessInfo?.logoImageUrl?.length) {
        return;
      }
      return await fetch(
        `${process.env.REACT_APP_API_URL}/${businessInfo.logoImageUrl}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: `Token ${access_token}`,
          },
        }
      )
        .then((result) => result.blob())
        .then((b) => {
          setLogoUrl(window.URL.createObjectURL(b));
        })
        .catch((e) => {
          console.error(e);
        });
    };
    getLogo();
  }, [access_token, businessInfo.logoImageUrl]);

  if (canViewComments) {
    return <></>;
  }

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className={classes.spaceTop}
    >
      {displayLogo && !hasBusinessLocations && logoUrl?.length > 0 && (
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <img
              className={classes.img}
              src={logoUrl}
              alt="Logo"
              onError={({ currentTarget }) => {
                currentTarget.style.display = "none";
              }}
            />
          </Grid>
        </Grid>
      )}

      {displayCompanyAddress && address?.length > 0 && (
        <Grid item xs={12} className={classes.noWrap}>
          <Typography variant="subtitle1" className={classes.spacing}>
            <img src={location} alt="website" className={classes.margin} />
            {address}
          </Typography>
        </Grid>
      )}

      {displayCompanyURL && webPage?.length > 0 && (
        <Grid item xs={12} className={classes.align}>
          <Typography variant="subtitle1">
            <img src={website} alt="website" className={classes.margin} />
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://${webPage}`}
              className={[classes.underline, classes.spacing].join(" ")}
            >
              {webPage}
            </a>
          </Typography>
        </Grid>
      )}

      {displayCompanyPhoneNumber && phoneNumber?.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="subtitle1" className={classes.spacing}>
            <img src={phone} alt="phone" className={classes.margin} />
            {phoneNumber}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
